import React from 'react';
import Localization from 'lib/localization';

type Props = {
    children?: string | React.ReactChild | React.ReactChild[];
};

function addEmptyAltToImages(text: string) {
    // This RegEx matches <img> tags that do not have an 'alt' attribute
    const regex = /<img((?![^>]*\balt\b)[^>])*>/gi;
    const replacer = (match: string) => {
        return match.replace(/\/?>/, ' alt="" />');
    };

    // Replace the found <img> tags without 'alt' attributes with modified ones
    return text.replace(regex, replacer);
}

export function addNewWindowLabelToAnchors(text: string) {
    // This RegEx matches <a> tags with a 'target="_blank"' attribute and without a11y-visually-hidden block inside
    // this is not bulletproof method, as we might have some other a11y-visually-hidden blocks inside, but it's good enough for now
    const regex =
        /<a\s+([^>]*?)target=['"]_blank['"]([^>]*?)>((?:(?!<span class="a11y-visually-hidden">).)*?)<\/a>/gis;
    const targetBlankLabel = `<span class="a11y-visually-hidden"> ${Localization.get(
        'mw@link.a11y.label.new-window'
    )}</span>`;
    const replacer = (
        _match: string,
        preTargetAttributes: string,
        postTargetAttributes: string,
        linkText: string
    ) => {
        // Construct the <a> tag with all attributes preserved and append the targetBlankLabel to the link text
        return `<a ${preTargetAttributes}target="_blank"${postTargetAttributes}>${linkText}${targetBlankLabel}</a>`;
    };

    // Replace the found <a> tags with 'target="_blank"' with modified ones
    return text.replace(regex, replacer);
}

const FormattedText: React.FC<Props> = (props) => {
    let text = props.children;

    if (typeof text === 'string') {
        text = addEmptyAltToImages(text);
        text = addNewWindowLabelToAnchors(text);

        return <div className="formatted-text" dangerouslySetInnerHTML={{ __html: text }}></div>;
    }

    return <div className="formatted-text">{text}</div>;
};

export default FormattedText;
